import axios from "@/lib/request";

// ===== 预约货运险订单相关接口 =====

// 获取货运订单列表
export const getHyxOrderList = (params) => {
  return axios.request({
    url: "/v1/admin/hyx/order/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取货运订单详情
export const getHyxOrderInfo = (params) => {
  return axios.request({
    url: "/v1/admin/hyx/order/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 修订预约货运险订单信息
export const reviseHyxOrder = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/order/revise",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除货运订单
export const deleteHyxOrder = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/order/delete",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取货运订单统计信息（保费总计等）
export const getHyxOrderStats = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/transaction/insurance/sum",
    method: "get",
    params: {
      ...params,
      product_alias: 'hyx'
    },
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 导出货运订单数据
export const exportHyxOrderList = (params) => {
  return axios.request({
    url: "/v1/admin/hyx/order/export",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 录入保单信息
export const inputHyxOrderPolicy = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/order/policy/input",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取货运价格方案列表
export const getHyxPriceList = (params) => {
  return axios.request({
    url: "/v1/admin/hyx/price/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取城市列表（用于不保地区和加费地区选择）
export const getCityList = () => {
  return axios.request({
    url: "/v1/admin/underwrite/city/list",
    method: "get",
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取承保确认单样式列表
export const getConfirmationTypeList = () => {
  return axios.request({
    url: "/v1/admin/hyx/price/listForConfirmationType",
    method: "get",
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取出单方案名称列表
export const getPolicyNameList = () => {
  return axios.request({
    url: "/v1/admin/hyx/price/listForPolicy",
    method: "get",
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除价格方案
export const deleteHyxPriceScheme = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/price/delete",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'AppKey': 'BpLnfgDs'
    }
  });
};
